const routes = {
  QuickLinks: () => '/quick-links',
};

export const DEV_ROUTE_KEYS = {
  QuickLinks: 'QuickLinks',
};

export default routes;
